var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"developer-area"},[_c('h2',[_vm._v("Webmaster area")]),_c('div',{staticClass:"btn-box"},[_c('s-btn',{attrs:{"icon":"line-chart"},on:{"click":_vm.onImproveClick}},[_vm._v("Improve your SEO rankings")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }